module.exports = __webpack_public_path__ + "static/media/compare_3.ce04cefe.svg";